import {createFileRoute, redirect} from '@tanstack/react-router';

import QuickDiagnosticReportRequest from '@/practitioner/views/diagnosticReport/QuickDiagnosticReportRequest';
import {AppRouterContext} from '@/shared/routing';
import {USER_HOME} from '@/shared/routing/paths';

export const Route = createFileRoute(
  '/(practitioner)/practitioner/quick-diagnostic-report-request'
)({
  component: QuickDiagnosticReportRequest,
  beforeLoad: function ({context}: {context: AppRouterContext}) {
    if (!context.company?.isTakePhotoEnabledForPractitioner) {
      throw redirect({to: USER_HOME, replace: true});
    }
  }
});
